module.exports = __webpack_public_path__ + "img/frame.c30389f4.png";